export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7345.12af7d48.jpg";